import script from "./Computer.vue?vue&type=script&setup=true&lang=js"
export * from "./Computer.vue?vue&type=script&setup=true&lang=js"

import "./Computer.vue?vue&type=style&index=0&id=0b21cefb&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b21cefb"]])

export default __exports__